import { createFileRoute } from '@tanstack/react-router';

import { PublicCertifications } from '@/features/certifications/PublicCertifications';

export const Route = createFileRoute('/certifications/public/$contactId')({
  component: PublicCertifications,
});
